import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance141vh6u7faopd as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.x26_1 = key;
        this.y26_1 = value;
      }
      m3() {
        return this.x26_1;
      }
      n3() {
        return this.y26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.x26_1) + ', value=' + toString(this.y26_1) + ')';
      }
      hashCode() {
        var result = this.x26_1 == null ? 0 : hashCode(this.x26_1);
        result = imul(result, 31) + (this.y26_1 == null ? 0 : hashCode(this.y26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.x26_1, other.x26_1))
          return false;
        if (!equals(this.y26_1, other.y26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.b27_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.t1n('key', keySerializer.a1n());
          $this$buildSerialDescriptor.t1n('value', valueSerializer.a1n());
          return Unit_instance;
        });
      }
      a1n() {
        return this.b27_1;
      }
      c27(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      d27(_this__u8e3s4) {
        return this.c27((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      e27(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      f27(_this__u8e3s4) {
        return this.e27((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g27(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.m27_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.t1n('first', keySerializer.a1n());
          $this$buildClassSerialDescriptor.t1n('second', valueSerializer.a1n());
          return Unit_instance;
        });
      }
      a1n() {
        return this.m27_1;
      }
      n27(_this__u8e3s4) {
        return _this__u8e3s4.xe_1;
      }
      d27(_this__u8e3s4) {
        return this.n27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      o27(_this__u8e3s4) {
        return _this__u8e3s4.ye_1;
      }
      f27(_this__u8e3s4) {
        return this.o27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      g27(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.e1s($this.s27_1, 0, $this.p27_1);
  var b = composite.e1s($this.s27_1, 1, $this.q27_1);
  var c = composite.e1s($this.s27_1, 2, $this.r27_1);
  composite.s1r($this.s27_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.i1s($this.s27_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.e1s($this.s27_1, 0, $this.p27_1);
        break;
      case 1:
        b = composite.e1s($this.s27_1, 1, $this.q27_1);
        break;
      case 2:
        c = composite.e1s($this.s27_1, 2, $this.r27_1);
        break;
      default:
        throw SerializationException().v1o('Unexpected index ' + index);
    }
  }
  composite.s1r($this.s27_1);
  if (a === get_NULL())
    throw SerializationException().v1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().v1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().v1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.p27_1 = aSerializer;
        this.q27_1 = bSerializer;
        this.r27_1 = cSerializer;
        var tmp = this;
        tmp.s27_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.t1n('first', this.p27_1.a1n());
          $this$buildClassSerialDescriptor.t1n('second', this.q27_1.a1n());
          $this$buildClassSerialDescriptor.t1n('third', this.r27_1.a1n());
          return Unit_instance;
        });
      }
      a1n() {
        return this.s27_1;
      }
      t27(encoder, value) {
        var structuredEncoder = encoder.r1r(this.s27_1);
        structuredEncoder.j1t(this.s27_1, 0, this.p27_1, value.qt_1);
        structuredEncoder.j1t(this.s27_1, 1, this.q27_1, value.rt_1);
        structuredEncoder.j1t(this.s27_1, 2, this.r27_1, value.st_1);
        structuredEncoder.s1r(this.s27_1);
      }
      b1n(encoder, value) {
        return this.t27(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      c1n(decoder) {
        var composite = decoder.r1r(this.s27_1);
        if (composite.h1s()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.h27_1 = keySerializer;
        this.i27_1 = valueSerializer;
      }
      j27(encoder, value) {
        var structuredEncoder = encoder.r1r(this.a1n());
        structuredEncoder.j1t(this.a1n(), 0, this.h27_1, this.d27(value));
        structuredEncoder.j1t(this.a1n(), 1, this.i27_1, this.f27(value));
        structuredEncoder.s1r(this.a1n());
      }
      b1n(encoder, value) {
        return this.j27(encoder, value);
      }
      c1n(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.a1n();
        var composite = decoder.r1r(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.h1s()) {
            var key = composite.e1s(this.a1n(), 0, this.h27_1);
            var value = composite.e1s(this.a1n(), 1, this.i27_1);
            tmp$ret$1 = this.g27(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.i1s(this.a1n());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.e1s(this.a1n(), 0, this.h27_1);
                break;
              case 1:
                value_0 = composite.e1s(this.a1n(), 1, this.i27_1);
                break;
              default:
                throw SerializationException().v1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().v1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().v1o("Element 'value' is missing");
          tmp$ret$1 = this.g27(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.s1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
